import React from 'react';
import PropTypes from 'prop-types';

var Field = function Field(_ref) {
  var label = _ref.label,
      children = _ref.children,
      error = _ref.error;
  return React.createElement(
    'div',
    { className: 'field' },
    label && React.createElement(
      'div',
      { className: 'field__label' },
      label
    ),
    children && React.createElement(
      'div',
      { className: 'field__control' },
      children
    ),
    error && React.createElement(
      'div',
      { className: 'field__error' },
      error
    )
  );
};

Field.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.node,
  children: PropTypes.node,
  error: PropTypes.node
} : {};

export default Field;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/field/field.js
// module id = null
// module chunks = 